import * as React from 'react';
import { cn } from '../utils';
import { Icon } from './icons/Icon';

type BaseChipAttributes = Pick<
  React.HTMLAttributes<HTMLSpanElement>,
  'className' | 'children' | 'style'
>;

export interface ChipProps extends BaseChipAttributes {
  children?: React.ReactNode;
  /** When provided, renders a remove button. */
  onRemove?: () => void;
  /** Accessible label for the remove button. */
  removeLabel?: string;
  /** Disables the remove button. */
  disabled?: boolean;
}

export const Chip = React.forwardRef<HTMLSpanElement, ChipProps>(
  ({ className, children, onRemove, removeLabel, disabled, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center gap-2xs rounded-full border border-border-base bg-background-muted text-foreground-muted px-sm py-2xs text-2xs font-medium whitespace-nowrap shrink-0',
          className
        )}
        {...props}
      >
        {children}
        {onRemove && (
          <button
            type='button'
            onClick={onRemove}
            disabled={disabled}
            aria-label={removeLabel}
            className='flex items-center text-foreground-muted hover:text-foreground-base disabled:opacity-50 disabled:cursor-not-allowed'
          >
            <Icon name='xmark' className='w-3! h-3!' />
          </button>
        )}
      </span>
    );
  }
);

Chip.displayName = 'Chip';
